import request from "@/utils/request.js";
// 注册验证手机号，姓名是否重复
export function valiisusr(params) {
  return request({
    url: "/isp/user/valiisusr",
    method: "get",
    params: params,
  });
}
// 个人用户/企业注册
export function register(data) {
  return request({
    url: "/api/user/add",
    method: "post",
    data,
  });
}

// 保存当前用户信息 - 个人;
export function updateUser(data) {
  return request({
    url: "​/infor​/save",
    method: "get",
    params: data,
  });
}

// 获取验证码;
export function getCode(phone) {
  return request({
    url: `/api/user/send/code/${phone}`,
    method: "get",
  });
}

// 校验验证码

export function checkPhoneCode(phone,code) {
  return request({
    url: `/api/user/check/code/${phone}/${code}`,
    method: "get",
  });
}

// 保存企业用户管理信息;
export function updateEntUser(data) {
  return request({
    url: "​/infor​/updatethaent",
    method: "get",
    params: data,
  });
}
